import { AxiosResponse } from "axios";

import { removeEmpty } from "../../utils/removeEmpty";
import { ApiPesquisa } from "../../Apis/Pesquisa";
import {
  IQuestionarioCompletoDTO,
  IQuestionarioDTO,
  IQuestionarioRespostaForm,
} from "../../types/questionario";

const basePath = "/questionario";

export class Questionario {
  static async responder(
    props: IQuestionarioRespostaForm
  ): Promise<AxiosResponse<IQuestionarioDTO>> {
    const data = removeEmpty(props);
    return ApiPesquisa.post(`${basePath}/responder`, data);
  }

  static async getById({
    uuidQuestionario,
  }: {
    uuidQuestionario: string;
  }): Promise<AxiosResponse<IQuestionarioCompletoDTO>> {
    return ApiPesquisa.get(`${basePath}/${uuidQuestionario}`);
  }
}
